module.exports = __webpack_public_path__ + "img/18_80.e0583cb3.png";